import { module } from 'modujs'
import { gsap } from '../gsap'

export default class TeamList extends module {

    static get settings() {
        return {
            PAGINATION: 12,
        }
    }

    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el
        this.$loadMore = Array.from(this.$('loadMore'))
        this.$members = Array.from(this.$('member'))
        this.$activeMembers = this.$members
        this.activeMembersCount = this.$activeMembers.length
        this.paginationIndex = 0

        gsap.set(this.$members, {
            display: 'none',
        })

        // Events
        this.events = {
            click: {
                loadMore: 'show',
            }
        }
    }

    init() {
        this.show(false)
    }

    update(id) {

        this.call('scrollTo', { target: this.$el }, 'Scroll')

        gsap.to(this.$activeMembers, {
            opacity: 0,
            yPercent: 10,
            stagger: 0.02,
            ease: 'power2.in',
            duration: 0.25,
            onComplete: () => {

                gsap.set(this.$members, {
                    display: 'none',
                })

                this.$activeMembers = id === '*' ? this.$members : this.$members.filter($member => {
                    return JSON.parse($member.dataset.categories).includes(id)
                })
                this.activeMembersCount = this.$activeMembers.length
                this.paginationIndex = 0

                this.show()
            }
        })
    }

    show(focus=true) {
        this.paginationIndex++

        const $membersToDisplay = this.$activeMembers.slice((this.paginationIndex - 1) * TeamList.settings.PAGINATION, (this.paginationIndex * TeamList.settings.PAGINATION))

        // No load more
        if (this.paginationIndex * TeamList.settings.PAGINATION >= this.activeMembersCount) {
            gsap.set(this.$loadMore, {
                opacity: 0
            })
        }
        // Load more
        else {
            gsap.set(this.$loadMore, {
                opacity: 1
            })
        }

        gsap.set($membersToDisplay, {
            clearProps: 'all',
        })

        gsap.from($membersToDisplay, {
            opacity: 0,
            yPercent: 10,
            stagger: 0.1,
            ease: 'power2.out',
            duration: 0.5,
            onStart: () => {
                if(focus !== false) {
                    $membersToDisplay?.[0].querySelector?.('a').focus?.({ focusVisible: true })
                }
            }
        })
    }

    destroy() {
    }
}
